var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 8H17","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10 1L17 8L10 15","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Arrow.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
